/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { motion } from 'framer-motion';
import { PriceHandler } from '../../redux/helper/CamelCase';

function ItemPriceTooltip({
    prod, hover, itemPriceValue,
}) {
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            id="tooltip-discountPercentage"
            role="tooltip"
            className={`inline-block absolute ${hover ? 'visible' : 'invisible'} z-[5] sm:p-2.5 p-2 bg-white rounded-lg shadow-s2 sm:w-[225px] w-[210px] ml-2`}
        >
            <div className="flex items-center justify-between">
                <p className="text-sm font-normal text-[#555259]">Unit Rate </p>
                <p className="text-lg font-semibold text-[#555259]">
                    {PriceHandler(itemPriceValue)}
                </p>
            </div>
            <div className="tooltip-arrow" data-popper-arrow />
        </motion.div>
    );
}

export default ItemPriceTooltip;
